import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'ze-login-error',
  standalone: false,
  templateUrl: './login-error.component.html',
  styleUrl: './login-error.component.css',
})
export class LoginErrorComponent {
  readonly ar = inject(ActivatedRoute);
  readonly router = inject(Router);

  get reason() {
    return this.ar.snapshot.queryParams['reason'];
  }

  async retry() {
    await this.router.navigate(['/']);
  }
}
